import { faFacebook, faInstagram, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import logo from '../../images/logo.png'

const Footer = () => {
    return (
        <div className="bg-dark mt-5 p-5">
            <Container>
                <Row className="py-5">
                    {/*Adding logo in footer*/}
                    <Col>
                        <img src={logo} alt="" />
                    </Col>
                    <Col>
                        <h5 className='text-white'>Company</h5>
                        <div className="d-flex flex-column text-white">
                            <a className="text-decoration-none link-light" href="#home">Home</a>
                            <a className="text-decoration-none link-light my-2" href="#terms">Terms of use</a>
                            <a className="text-decoration-none link-light" href="#careers">Careers</a>
                        </div>

                    </Col>
                    <Col>
                        <h5 className='text-white'>Teachers</h5>
                        <div className="d-flex flex-column ">
                            <a className="text-decoration-none link-light" href="#teacher">Become a Teacher</a>
                            <a className="text-decoration-none link-light my-2" href="#faq">FAQ</a>
                            <a className="text-decoration-none link-light" href="#blog">Blog</a>
                        </div>
                    </Col>
                    <Col>
                        <h5 className='text-white'>Support</h5>
                        <div className="d-flex flex-column">
                            <a className="text-decoration-none link-light" href="#contact">Contact Us</a>
                            <a className="text-decoration-none link-light my-2" href="#community">Community</a>
                            <a className="text-decoration-none link-light" href="#guidelines">Guidelines</a>
                        </div>
                    </Col>
                </Row>

            </Container>
            <hr className='text-white w-75 mx-auto' />
            <div className="d-flex justify-content-between py-4 my-4 text-white">
                {/*Adding copyright text*/}
                <p className="w-50 ">&copy; 2021 English Baksho. All rights reserved.</p>
                {/*Adding social media icons*/}
                <div className="d-flex w-25">
                    <FontAwesomeIcon className="me-3" icon={faFacebook} size="lg" />
                    <FontAwesomeIcon className="me-3" icon={faInstagram} size="lg" />
                    <FontAwesomeIcon className="me-3" icon={faTwitter} size="lg" />
                    <FontAwesomeIcon className="me-3" icon={faLinkedinIn} size="lg" />
                </div>
            </div>
        </div>
    );
};

export default Footer;